"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["id"]; // TODO: Добавить функциональность копирования идентификатора при нажатии на него.
var TicketId = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var id = _ref.id,
    restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledTicketId, restProps, id);
});
TicketId.displayName = 'TicketId';
TicketId.propTypes = {
  className: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired
};
TicketId.defaultProps = {
  className: ''
};
var StyledTicketId = _styledComponents["default"].div.withConfig({
  displayName: "TicketId__StyledTicketId",
  componentId: "sc-15v94gt-0"
})(["color:#919499;font-size:12px;text-transform:uppercase;"]);
var _default = exports["default"] = TicketId;